import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dc8c395"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "currency-input" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "number",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      class: _normalizeClass(["currency-input__control default-input", _ctx.inputClass]),
      disabled: _ctx.disabled
    }, null, 10, _hoisted_2), [
      [_vModelText, _ctx.value]
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["currency-input__sign", {'currency-input__sign--disabled': _ctx.disabled}])
    }, _toDisplayString(_ctx.currencySymbol), 3)
  ]))
}